export const formatRecordedAt = (value) => {
    if (!value) return 'Heure de saisie non disponible';

    return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).format(new Date(value));
};

export const causesLabel = (causes = []) => {
    const labels = causes
        .map(cause => cause?.label)
        .filter(Boolean);

    return labels.length ? labels.join(' · ') : 'Aucune cause associée';
};

export const observationAriaLabel = (observation, unit = '') => {
    const value = observation?.value ?? '—';
    const date = observation?.date || 'date inconnue';
    return `Relevé de ${value} ${unit} le ${date}. ${causesLabel(observation?.causes || [])}`.trim();
};
